module.exports = __webpack_public_path__ + "static/media/qr_tip.cbddc28c.svg";